// @flow
'use strict';

import * as React from 'react';

import type { ICofinsQtde, ICofinsOutr } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type ValorCofinsProps = {
  item : ICofinsQtde | ICofinsOutr,
};

export default function ValorCofins({ item } : ValorCofinsProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="cst">CST</ColumnDetalhes>
        <ColumnDetalhes field="valorCofins" type="moeda">Valor da COFINS</ColumnDetalhes>
      </RowDetalhes>
  );
}